import { makeAutoObservable } from 'mobx';
import { isActiveSubscriberTask } from 'global/services-helpers/electionService';
import { SubChecklistCard, SubscriberTask } from 'types/electionService';
import { ChecklistOption } from 'types/enrollmentService';

/** Task-catalog behavior for a subscriber: checklist options and active/inactive task lists. */
export default class SubscriberTasksDelegate {
  private _tasks: SubscriberTask[];

  public get activeTasks(): SubscriberTask[] {
    return this._tasks.filter(isActiveSubscriberTask);
  }

  public get inactiveTasks(): SubscriberTask[] {
    return this._tasks.filter((task) => !isActiveSubscriberTask(task));
  }

  public getTaskChecklistOptions(entityId: string): ChecklistOption<SubChecklistCard>[] {
    return this._tasks.find((task) => task.entityId === entityId)?.checklist?.checklistOptions || [];
  }

  public setTasks(tasks: SubscriberTask[]): void {
    this._tasks = tasks;
  }

  constructor(tasks: SubscriberTask[] = []) {
    this._tasks = tasks;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
